import { TEXT_STRING } from '../../constants';

export enum EScheduleCellKind {
  EMPTY = 'empty',
  READY_TO_GO = 'readyToGo',
  TIME = 'time',
  TO_BE_CONFIRMED = 'toBeConfirmed',
}

export type ResolveScheduleCellInput = {
  disabled: boolean;
  startTime?: string;
  endTime?: string;
  shiftAreaName?: string;
  profileAreaName?: string;
  showReadyToGo: boolean;
  isToBeConfirmed: boolean;
  isFirstCell: boolean;
};

export type ResolveScheduleCellResult = {
  kind: EScheduleCellKind;
  timeText: string;
  areaText: string;
};

export function resolveScheduleCell(
  input: ResolveScheduleCellInput,
): ResolveScheduleCellResult {
  const {
    disabled,
    startTime,
    endTime,
    shiftAreaName,
    profileAreaName,
    showReadyToGo,
    isToBeConfirmed,
    isFirstCell,
  } = input;

  const hasValidShift = !disabled && Boolean(startTime);

  let kind: EScheduleCellKind;
  if (showReadyToGo) {
    kind = EScheduleCellKind.READY_TO_GO;
  } else if (hasValidShift) {
    kind = EScheduleCellKind.TIME;
  } else if (isToBeConfirmed && isFirstCell) {
    kind = EScheduleCellKind.TO_BE_CONFIRMED;
  } else {
    kind = EScheduleCellKind.EMPTY;
  }

  switch (kind) {
    case EScheduleCellKind.READY_TO_GO:
      return {
        kind,
        timeText: TEXT_STRING.SEARCH_PAGE.GO_NOW,
        areaText: hasValidShift
          ? (shiftAreaName ?? '')
          : (profileAreaName ?? ''),
      };
    case EScheduleCellKind.TIME:
      return {
        kind,
        timeText: `${startTime}\n-\n${endTime || '\n'}`,
        areaText: shiftAreaName ?? '',
      };
    case EScheduleCellKind.TO_BE_CONFIRMED:
      return {
        kind,
        timeText: TEXT_STRING.SEARCH_PAGE.TO_BE_CONFIRM,
        areaText: profileAreaName ?? '',
      };
    case EScheduleCellKind.EMPTY:
      return {
        kind,
        timeText: '-',
        areaText: '-',
      };
  }
}
